import { render, staticRenderFns } from "./SingleInfo.vue?vue&type=template&id=7c1e6561&scoped=true&"
import script from "./SingleInfo.vue?vue&type=script&lang=js&"
export * from "./SingleInfo.vue?vue&type=script&lang=js&"
import style0 from "./SingleInfo.vue?vue&type=style&index=0&id=7c1e6561&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1e6561",
  null
  
)

export default component.exports